import CustomDropdown from '../../components/CustomDropdown';
import React, { Component } from "react";
import { FormHelperText, Input, FormControl, Divider, Popover, Button, IconButton, Icon, withStyles, Card, DialogContent, Dialog, DialogActions, DialogTitle, Typography, MenuItem, InputLabel, Radio, FormControlLabel, RadioGroup, Badge, Drawer, Tooltip } from "@material-ui/core";
import Grid, { default as MaterialGrid } from '@material-ui/core/Grid';
import ReportSidebarMenu from "../Layout/ReportSidebarMenu";
import Select from '@material-ui/core/Select';
import FilterListIcon from '@material-ui/icons/FilterList';

import { DateRangePicker, DateRange } from "materialui-daterange-picker";
import moment from 'moment';//moment
import 'moment-timezone';//timezone
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

import { opportunityFilterComponent } from './opportunityFilterComponent';
import { ValidatorForm, TextValidator, SelectValidator } from "react-material-ui-form-validator";

import { Link } from "react-router-dom";
import * as actions from '../../store/actions/index';
import { connect } from "react-redux";

class SalesForecast extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportTitile: "Sales Forecast",
            reportSubTitle: "Amount forecasted to be closed based on the deal amount, win probability, and close date.",
            totalvalue: "$0K",
            totalWinRate: "0%",
            selectedPipline: "1",
            selectedFilter: "1",
            value_type: "1",
            drawerOpen: false,
            dateopen: false,
            dateformat: 'MM/DD/YYYY',
            datetype: "3",

            selectedDate: { from: moment().startOf("year").format('YYYY-MM-DD'), to: moment().endOf("year").format('YYYY-MM-DD') },
            selectedDatelabel: "This Year",
            definedRanges: [
                {
                    label: "Today",
                    startDate: moment().format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD')
                },

                {
                    label: "Yesterday",
                    startDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
                    endDate: moment().subtract(1, 'days').format('YYYY-MM-DD')
                },

                {
                    label: "This Week",
                    startDate: moment().day(1),
                    endDate: moment().day(7)
                },

                {
                    label: "This Month",
                    startDate: moment().startOf("month"),
                    endDate: moment().endOf("month")
                },

                {
                    label: "This Quarter",
                    startDate: moment().startOf('quarter'),
                    endDate: moment().endOf('quarter')
                },

                {
                    label: "This Year",
                    startDate: moment().startOf('year'),
                    endDate: moment().endOf('year')
                },

                {
                    label: "Last 7 days",
                    startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD')
                },

                {
                    label: "Last 30 days",
                    startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD')
                },
            ],
            fromdate: moment().startOf("month").format('YYYY-MM-DD'),
            todate: moment().endOf('month').format('YYYY-MM-DD'),
            pipelineList: [],
            salesForecastSummary: [],
            fieldDisplay: [],
            dropdownhide: [],
            systemTagsList: [],
            masterActivityTypesList: [],
            usersListArray: [],

            filterSaveDialoge: false,
            fitertype: "1",
            filterRangeArray: [],
            filterObject: {},
            filternameError: false,
            filtername: "",
            displaySelectedFilterName: "Sales Forecast",
            filterdata: [],
            recordtypeid: 4,
            reportno: 2,
            filterlist: [],
            AllOpportunityFilterKey: [],
            allowStateUpdateFilter: true,
            anchorEl: null,
            isOpenedFiltersDefault: false,
            activityquery: 'any',
            allDefaultKeyFilter: { id: 0, filteroption: [], filtername: "All Opportunity" },
        }
    }

    componentWillMount() {

        localStorage.removeItem('selected_report_pipeline_summary_filter_id');

        let forecastparams = {
            filterdata: [],
            piplineid: parseFloat(this.state.selectedPipline),
            type: parseFloat(this.state.value_type),
            fromdate: moment().startOf("year").format('YYYY-MM-DD'),
            todate: moment().endOf('year').format('YYYY-MM-DD'),
            datetype: parseFloat(this.state.datetype),
        };
        this.getForecastSummary(forecastparams);

        // setTimeout(() => {
        //     this.getForecastSummary(forecastparams);
        // }, 2000);

        this.props.getPipelines(this.props.apolloClient.client);
        let val = { typeId: 4 }
        this.props.customFieldList(this.props.apolloClient.client, val);
        this.props.getTagsList(this.props.apolloClient.client);
        this.props.getUserList(this.props.apolloClient.client);
        this.props.getActivityTypes(this.props.apolloClient.client);

        this.setState({ selectedDate: { from: moment().startOf("year").format('YYYY-MM-DD'), to: moment().endOf("year").format('YYYY-MM-DD') } })
    }

    componentWillReceiveProps(props) {
        if (props.settingReducer.userSettingArray && props.settingReducer.userSettingArray.data) {
            let usersetting = props.settingReducer.userSettingArray.data;
            this.setState({ dateformat: usersetting.dateformat, timeZone: usersetting.timezone })
        }

        if (props.settingReducer.masterActivityTypesList && props.settingReducer.masterActivityTypesList.is_loaded == true && props.settingReducer.masterActivityTypesList.data) {
            props.settingReducer.masterActivityTypesList.is_loaded = false
            var dataList = props.settingReducer.masterActivityTypesList.data;
            var count = dataList.filter(function (element) {
                if (element.is_disable == true) {
                    return element
                }
            });
            this.setState({
                masterActivityTypesList: dataList,
            });
        }

        if (props.reportReducer.forecastreportfilterlist.data && this.state.allowStateUpdateFilter ) {
            // props.reportReducer.forecastreportfilterlist.is_loaded = false;
            const filterlist = props.reportReducer.forecastreportfilterlist.data;
            // console.log(props.reportReducer.forecastreportfilterlist,'sales forecast');
            let displaySelectedFilterName = this.state.displaySelectedFilterName;
            var AllfilterIdKey = this.findWithAttr(filterlist, 'id', "3");

            if (AllfilterIdKey != -1) {
                this.setState({ AllOpportunityFilterKey: AllfilterIdKey })
            }
            //Aplying default filter selected  STRAT

            let defaultFilter;
            //checkdefault filter  in localStorage
            var localStorageFilterId = localStorage.getItem('selected_report_pipeline_summary_filter_id');
            if (localStorageFilterId) {
                var localId = this.findWithAttr(filterlist, 'id', localStorageFilterId);
                defaultFilter = filterlist[localId];

                this.setState({ displaySelectedFilterName: (defaultFilter && defaultFilter.length > 0) ? defaultFilter.filtername : displaySelectedFilterName })
            } else {
                var defaultKeyStatus = this.findWithAttr(filterlist, 'id', "3");
                if (defaultKeyStatus != -1) {
                    defaultFilter = filterlist[defaultKeyStatus];
                    localStorage.setItem('selected_report_pipeline_summary_filter_id', defaultFilter.id);

                    this.setState({ displaySelectedFilterName: defaultFilter.filtername })
                }
                // console.log(defaultKeyStatus, filterlist, defaultFilter,'defaultFilter');
            }

            if (this.state.newSavedFilterName) {
                this.setState({ displaySelectedFilterName: this.state.newSavedFilterName })
            }

            this.setState({ filterlist: filterlist, allowStateUpdateFilter: false })
            //updateFilter name to display and menudisplay array set
            this.setState({
                fieldDisplay: [],
                dropdownhide: [],
            })

            if (defaultFilter && defaultFilter.filteroption.length > 0) {
                let filterObject = this.state.filterObject;
                let filterRangeArray = this.state.filterRangeArray;
                let displayField = []
                let dropdownhideShow = []
                var promise = new Promise((resolve, reject) => {
                    defaultFilter.filteroption.map((val, k) => {
                        if (val.name == "activitytype") {
                            this.setState({ activityquery: val.query })
                            if (val.value.length > 0) {
                                var arr = []
                                val.value.map(v => {
                                    var k = this.findWithAttr(this.state.masterActivityTypesList, 'id', v)
                                    if (k != -1) {
                                        arr.push(this.state.masterActivityTypesList[k])
                                    }
                                })
                                val.value = arr;

                            }
                        }

                        filterObject = {
                            ...filterObject,
                            [val.name]: val
                        }

                        if (val.name == "tags") {
                            this.setState({ tagsquery: val.query })
                        }

                        if (val.type === "range") {
                            filterRangeArray[val.name] = ["", ""];
                            filterRangeArray[val.name][0] = val.value[0];
                            filterRangeArray[val.name][1] = val.value[1];
                            this.setState({ filterRangeArray })
                            displayField.push(val.name)
                        }
                        if (val.type === "date") {
                            filterRangeArray[val.name] = ["", ""];
                            filterRangeArray[val.name][0] = val.value[0] == "" ? null : val.value[0];
                            filterRangeArray[val.name][1] = val.value[1] == "" ? null : val.value[1];
                            this.setState({ filterRangeArray })
                            if (val.value[0] != "" && val.value[1] != "") {
                                displayField.push(val.name)
                            } else if (val.value[0] != "" || val.value[1] != "") {
                                displayField.push(val.name)
                            }
                        }
                        if (val.name == "zipcode" || val.name == "city" || val.name == "state" || val.name == "country") {//hideshow ENABLE state/city/country/state
                            dropdownhideShow.push(val.name)
                        } else {
                            dropdownhideShow.push(val.name)
                        }
                    })
                    this.setState({
                        filterObject,
                        fieldDisplay: displayField,
                        dropdownhide: dropdownhideShow,
                        newSavedFilterName: "",
                    }, () => this.forceUpdate())
                    resolve(true)
                });

                promise.then(result => {
                    // if (localStorage.getItem('selected_pipeline_id')) {
                    //     this.setState({
                    //         selectedPipelineId: localStorage.getItem('selected_pipeline_id'),
                    //     }, () => this.forceUpdate())
                    // }
                    this.handleFilterSubmit();
                });
            }
            //Aplying default filter selected  END
        }

        if (props.settingReducer.pipelineListArray && props.settingReducer.pipelineListArray.data) {
            this.setState({ pipelineList: props.settingReducer.pipelineListArray.data })
        }

        if (props.settingReducer.usersListArray.data && this.state.usersListArray.length == 0) {
            const usersListArray = props.settingReducer.usersListArray.data;
            this.setState({ usersListArray: usersListArray })
        }

        if (props.settingReducer.systemTagsList.data && this.state.systemTagsList.length == 0) {
            const tagsData = props.settingReducer.systemTagsList.data;
            this.setState({ systemTagsList: tagsData })
        }

        if (props.reportReducer.salesForecastSummary && props.reportReducer.salesForecastSummary.data) {
            let salesForecastSummary = props.reportReducer.salesForecastSummary.data.data

            let totalweight = 0;
            let totalwon = 0;
            if (salesForecastSummary.weight.length > 0) {
                salesForecastSummary.weight.map((weight) => {
                    totalweight += weight[1];
                })
            }
            if (salesForecastSummary.won.length > 0) {
                salesForecastSummary.won.map((won) => {
                    totalwon += won[1];
                })
            }
            this.setState({ salesForecastSummary, totalvalue: "$" + ((salesForecastSummary.totaloppamount && salesForecastSummary.totaloppamount > 0) ? (salesForecastSummary.totaloppamount) : 0) });
        }

        if (props.settingReducer.opportunitiesCustomFieldList.data) {
            const customFields = props.settingReducer.opportunitiesCustomFieldList.data;
            this.setState({ fieldsList: customFields })
        }
    }

    findWithAttr = (array, attr, value) => {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i][attr] == value) {
                return i;
            }
        }
        return -1;
    }

    // filter functions ----------------------------
    handleClick = (event) => {
        this.setState({ anchorEl: event.target, isOpenedFiltersDefault: true });
    };

    handleClose = () => {
        this.setState({ anchorEl: null, isOpenedFiltersDefault: false });
    };

    handleFollowedCheckbox = (val, name) => {
        // console.log("name1", name);
        // console.log("val1", val);
        this.setState({
            filterObject: {
                ...this.state.filterObject,
                [name]: val
            }
        }, () => {
            setTimeout(() => {
                if (this.state.filterObject[name] == val) {
                    this.handleFilterSubmit()
                }
            }, 1500);
        })
    }

    handleChangeFilter = (val, name) => {

        console.log(val, name, 'val, name');
        this.setState({
            filterObject: {
                ...this.state.filterObject,
                [name]: val
            }
        }, () => {
            setTimeout(() => {
                if (this.state.filterObject[name] == val) {
                    this.handleFilterSubmit()
                }
            }, 3000);
        })
    };

    rangeClick = (key, id) => {
        var rangeData = this.state.filterRangeArray[key];
        if (this.state.filterRangeArray[key][0] == "" && this.state.filterRangeArray[key][1] == "") {
            rangeData = []
        }

        var value = { fieldid: id, name: key, type: "range", value: rangeData };
        this.setState({
            filterObject: {
                ...this.state.filterObject,
                [key]: value
            }
        }, () => {
            this.forceUpdate()
            setTimeout(() => {
                if (this.state.filterObject[key] == value) {
                    this.handleFilterSubmit()
                }
            }, 1500);
        })
    }

    rangeFilter = (rval, rname) => {
        let filterRangeArray = this.state.filterRangeArray;
        filterRangeArray[rname][rval.case] = rval.value;
        this.setState({ filterRangeArray })
    }

    rangeClickDate = (key, id) => {
        var rangeData = this.state.filterRangeArray[key];
        if (this.state.filterRangeArray[key][0] == "" && this.state.filterRangeArray[key][1] == "") {
            rangeData = []
        }

        var value = { fieldid: id, name: key, type: "date", value: rangeData };
        this.setState({
            filterObject: {
                ...this.state.filterObject,
                [key]: value
            }
        }, () => {
            this.forceUpdate()
            setTimeout(() => {
                if (this.state.filterObject[key] == value) {
                    this.handleFilterSubmit()
                }
            }, 1500);
        })
    }

    rangeFilterDate = (rval, rname) => {
        let filterRangeArray = this.state.filterRangeArray;
        filterRangeArray[rname][rval.case] = rval.value;
        this.setState({
            filterRangeArray
        }, () => {
            this.forceUpdate()
            setTimeout(() => {
                this.rangeClickDate(rname, rval.fieldid)
            }, 100);
        })
    }

    handleToggleFieldDisplay = (name) => {
        var exists = this.state.fieldDisplay.includes(name);
        var joined = [];
        let filterRangeArray = this.state.filterRangeArray;

        if (exists) {
            joined = this.state.fieldDisplay.filter((item) => item != name)
            if (filterRangeArray[name]) {
                //delete filterRangeArray[name];
            }
        } else {
            joined = this.state.fieldDisplay.concat(name);
            if (!filterRangeArray[name]) {
                filterRangeArray[name] = ["", ""];
            }
        }
        setTimeout(() => {
            this.setState({ fieldDisplay: joined, filterRangeArray })
        }, 100);
        
    }

    dropdownMenu = (fkey) => {
        var exists = this.state.dropdownhide.includes(fkey);
        var joined = [];
        if (exists) {
            joined = this.state.dropdownhide.filter((item) => item != fkey)
        } else {
            joined = this.state.dropdownhide.concat(fkey);
        }
        this.setState({ dropdownhide: joined })
    }

    handleFilterSubmit = () => {
        var allowToFilter = true
        let copyObj = JSON.parse(JSON.stringify(this.state.filterObject));
        var filterValuesArray = Object.keys(copyObj);
        var finalFilterData = filterValuesArray.map((k, i) => {
            let v = copyObj[k];

            if (v.value.length > 0) {
                var valuesArray = [];
                v.value.map((val, k) => {
                    if (v.type === "date") {
                        if (val == "Invalid Date") {
                            allowToFilter = false
                        } else if (val == "") {
                            valuesArray.push(val)
                        } else if (val == null) {
                            valuesArray.push("")
                        } else if (val != null) {
                            if (v.fieldid != "0") {
                                val = moment(val).format('YYYY-MM-DD');
                            } else {
                                //val = moment(val).format("X");
                                val = moment(val).format('MM/DD/YYYY');
                            }
                            valuesArray.push(val)
                        }
                    } else if (v.type == "log") {
                        valuesArray.push(val.id);
                    } else if (v.fieldid == '46' && val.email) {
                        valuesArray.push(val.email)
                    } else if (v.fieldid != '46' && val.name) {
                        valuesArray.push(val.name)
                    } else if (val.optionvalue) {
                        valuesArray.push(val.optionvalue)
                    } else if (v.fieldid === "56" || v.type === "range") {//tag array and value
                        valuesArray.push(val);
                    } else {
                        valuesArray.push(val);
                    }
                })


                let checkBoxKey = -1
                if (this.state.fieldsList != undefined) {
                    checkBoxKey = this.findWithAttr(this.state.fieldsList, 'id', v.fieldid);
                }



                v.value = valuesArray;
                if (v.type == "followed") {//follow/not follow filter only value is true
                    if (v.value[0] === true) {
                        return v
                    }
                } else if (checkBoxKey != -1 && this.state.fieldsList[checkBoxKey].fieldtype.id == "3" && v.value[0] == "1") {
                    return v
                } else if (checkBoxKey != -1 && this.state.fieldsList[checkBoxKey].fieldtype.id != "3") {
                    return v
                } else if (checkBoxKey != -1 && this.state.fieldsList[checkBoxKey].fieldtype.id == "3") {
                } else {
                    return v
                }
            }
        })

        //filter null and undefined object 
        finalFilterData = finalFilterData.filter(function (element) {
            return element !== undefined || (element !== undefined && element.value.length != 0);
        });
        console.log("allowToFilter", allowToFilter);
        console.log("finalFilterData", finalFilterData);
        if (allowToFilter) {
            //saveFilter Data for save in future use.
            this.setState({
                filterdata: finalFilterData,
                isDataLoading: true,
            })

            let forecastparams = {
                filterdata: this.state.filterdata,
                piplineid: parseFloat(this.state.selectedPipline),
                type: parseFloat(this.state.value_type),
                fromdate: this.state.fromdate,
                todate: this.state.todate,
                datetype: parseFloat(this.state.datetype),
            };

            this.getForecastSummary(forecastparams);
        }
    }

    handleSavefilter = () => {
        if (this.state.filtername == "") {
            this.setState({ filternameError: true })
            return false
        }
        if (this.state.filterdata && this.state.filterdata.length > 0) {
            let req = [];
            req['savefilter'] = {
                filterdata: this.state.filterdata,
                fitertype: this.state.fitertype,
                filtername: this.state.filtername,
                recordtypeid: this.state.recordtypeid,
                reportno: this.state.reportno,
            };
            req['getfilter'] = { reportno: this.state.reportno };
            console.log(req, 'filter save data');
            this.props.saveReportFilterDetail(this.props.apolloClient.client, req);
            this.handleSavefilterDialogeClose()
            this.setState({
                displaySelectedFilterName: this.state.filtername,
                newSavedFilterName: this.state.filtername,
            })
        } else {
            //dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
        }
        setTimeout(() => {
            this.setState({
                allowStateUpdateFilter: true,
            })
        }, 2000);
    }

    updateOpportunityFilter = (data) => {
        // console.log("data", data);
        this.setState({
            filterSaveDialoge: true,
            filterUpdateId: data.id,
            filtername: data.filtername,
            fitertype: data.fitertype.toString(),
            oldFilterOption: data.filteroption,
        })
    }

    handleUpdatefilter = () => {
        if (this.state.filtername == "") {
            this.setState({ filternameError: true })
            return false
        }
        let req = {
            filterdata: this.state.oldFilterOption,
            fitertype: this.state.fitertype,
            filtername: this.state.filtername,
            filterid: parseInt(this.state.filterUpdateId),
            reportno: this.state.reportno,
        }
        //return
        this.props.updateReportFilterDetail(this.props.apolloClient.client, req);
        let updateDataInState = this.findWithAttr(this.state.filterlist, 'id', this.state.filterUpdateId);
        if (updateDataInState !== -1) {
            this.state.filterlist[updateDataInState].filtername = this.state.filtername;
            this.state.filterlist[updateDataInState].fitertype = this.state.fitertype;
        }
        this.handleSavefilterDialogeClose()
    }

    updateFilterOptions = () => {
        let key = this.findWithAttr(this.props.reportReducer.forecastreportfilterlist.data, 'id', localStorage.getItem('selected_report_pipeline_summary_filter_id'));
        var data = ""
        if (key !== -1) {
            data = this.props.reportReducer.forecastreportfilterlist.data[key];
            if (this.state.filterdata && this.state.filterdata.length > 0) {
                let req = {
                    filterdata: this.state.filterdata,
                    fitertype: data.fitertype.toString(),
                    filtername: data.filtername,
                    filterid: parseInt(data.id),
                    reportno: this.state.reportno,
                }
                this.props.updateReportFilterDetail(this.props.apolloClient.client, req);
                this.handleSavefilterDialogeClose()
            } else {
                //dispatch(notificationAll(actionTypes.NOTIFICATIONS, returnData, false));
            }
            setTimeout(() => {
                this.setState({
                    allowStateUpdateFilter: true,
                })
            }, 1500);
        }
    }

    confirmDeleteFilter = () => {
        this.props.deleteReportFilter(this.props.apolloClient.client, { filterid: parseInt(this.state.filterDeleteId), reportno: this.state.reportno });
        let removeFilterObjKey = this.findWithAttr(this.props.reportReducer.forecastreportfilterlist.data, 'id', this.state.filterDeleteId);
        if (removeFilterObjKey !== -1) {
            if (!this.props.reportReducer.forecastreportfilterlist.data[removeFilterObjKey].isdefault == true) {
                this.props.reportReducer.forecastreportfilterlist.data.splice(removeFilterObjKey, 1);
            }
        }
        this.filterRemoveDialoge()
    }

    filterRemoveDialoge = () => {
        this.setState({ isDeleteFilter: false, filterDeleteId: "", allowStateUpdateFilter: true })
    }

    handleSavefilterDialoge = () => {
        this.setState({ filterSaveDialoge: true })
    }

    handleSavefilterDialogeClose = () => {
        this.setState({
            filterSaveDialoge: false,
            filternameError: false,
            fitertype: "1",
            filterUpdateId: "",
            oldFilterOption: "",
            filtername: "",
        })
    }

    handleFilterChange = (filterdata) => {
        // let filterkey = this.findWithAttr(this.state.filterlist, 'id', event.target.value);

        // let filterdata = this.state.filterlist[filterkey];

        //my open oppoertunity
        // if (filterdata.id == "2") {
        //     let udata = JSON.parse(localStorage.getItem('user_data_session'))
        //     filterdata.filteroption = [
        //         {
        //             fieldid: "46", name: "owner", type: "value", value: [udata.email]
        //         },
        //         {
        //             fieldid: "45", name: "status", type: "value", value: ["Open"]
        //         }
        //     ]
        // }

        //Opportunities Im Following
        // if (filterdata.id == "14") {
        //     filterdata.filteroption = [
        //         {
        //             fieldid: "0",
        //             name: "followed",
        //             type: "followed",
        //             value: [true],
        //             chktype: "follow",
        //         }
        //     ]
        // }

        //won opportunity
        // if (filterdata.id == "15") {
        //     let udata = JSON.parse(localStorage.getItem('user_data_session'))
        //     filterdata.filteroption = [
        //         {
        //             fieldid: "45", name: "status", type: "value", value: ["Won"]
        //         }
        //     ]
        // }

        //Open opportunity
        // if (filterdata.id == "1") {
        //     let udata = JSON.parse(localStorage.getItem('user_data_session'))
        //     filterdata.filteroption = [
        //         {
        //             fieldid: "45", name: "status", type: "value", value: ["Open"]
        //         }
        //     ]
        // }

        this.setState({
            filterObject: {},
            filterRangeArray: [],
            fieldDisplay: [],
            dropdownhide: [],
        }, () => {
            this.forceUpdate()
            this.setState({ displaySelectedFilterName: filterdata.filtername, currentPage: 0 })
            if (filterdata.filteroption.length > 0) {

                let filterObject = this.state.filterObject;
                // console.log(filterdata.filteroption, filterObject,'filterdata.filteroption');

                let filterRangeArray = this.state.filterRangeArray;
                let displayField = []
                let dropdownhideShow = []
                var promise = new Promise((resolve, reject) => {
                    filterdata.filteroption.map((val, k) => {
                        if (val.name == "activitytype") {
                            this.setState({ activityquery: val.query })
                            if (val.value.length > 0) {
                                var arr = []
                                val.value.map(v => {
                                    var k = this.findWithAttr(this.state.masterActivityTypesList, 'id', v)
                                    if (k != -1) {
                                        arr.push(this.state.masterActivityTypesList[k])
                                    }
                                })
                                val.value = arr;

                            }
                        }

                        filterObject = {
                            ...filterObject,
                            [val.name]: val
                        }
                        if (val.name == "tags") {
                            this.setState({ tagsquery: val.query })
                        }

                        if (val.type === "range") {
                            filterRangeArray[val.name] = ["", ""];
                            filterRangeArray[val.name][0] = val.value[0];
                            filterRangeArray[val.name][1] = val.value[1];
                            this.setState({ filterRangeArray })
                            displayField.push(val.name)
                        }

                        if (val.type == "date") {
                            filterRangeArray[val.name] = ["", ""];
                            filterRangeArray[val.name][0] = val.value[0] == "" ? null : val.value[0];
                            filterRangeArray[val.name][1] = val.value[1] == "" ? null : val.value[1];
                            this.setState({ filterRangeArray })
                            if (val.value[0] != "" && val.value[1] != "") {
                                displayField.push(val.name)
                            } else if (val.value[0] != "" || val.value[1] != "") {
                                displayField.push(val.name)
                            }
                        }

                    })
                    this.setState({
                        filterObject,
                        fieldDisplay: displayField,
                        dropdownhide: dropdownhideShow,
                    }, () => this.forceUpdate())
                    resolve(true)
                });

                promise.then(result => {
                    this.handleFilterSubmit();
                    localStorage.setItem('selected_report_pipeline_summary_filter_id', filterdata.id)
                });
            } else {
                console.log(filterdata, 'else');
                // let val = {
                //     filterdata: [],
                //     list: {
                //         limit: this.state.pageSize,
                //         pageno: 1,
                //         searchtext: this.state.searchText,
                //         sorttype: this.state.sorttype,
                //         type: "list",
                //         fieldId: this.state.fieldId,
                //         columnname: this.state.column_name,
                //         islimited:true
                //     },
                //     piplineid: parseFloat(this.state.selectedPipelineId),
                //     filterid: 1
                // }
                localStorage.setItem('selected_report_pipeline_summary_filter_id', filterdata.id)
                this.handleFilterSubmit();
            }
        })

    }

    updateFilterDefaultReport = (data) => {
        this.props.updateReportFilterDefault(this.props.apolloClient.client, { filterid: parseInt(data.id), reportno: this.state.reportno });
        setTimeout(() => {
            this.setState({
                allowStateUpdateFilter: true,
            })
        }, 2000);
    }

    // -----------------------------------------------------

    getForecastSummary = (forecastparams) => {
        let param = forecastparams
        param.memberid = 0
        this.props.salesForecastSummary(this.props.apolloClient.client, param);
        this.props.getReportFilterList(this.props.apolloClient.client, { reportno: 2 });
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value })
    }

    handleOpenDrawer = () => {
        this.setState({ drawerOpen: true, })
        this.closedatepicker();
    }

    handlePiplineChange = (event) => {
        let forecastparams = {
            filterdata: this.state.filterdata,
            piplineid: parseFloat(event.target.value),
            type: parseFloat(this.state.value_type),
            fromdate: this.state.fromdate,
            todate: this.state.todate,
            datetype: parseFloat(this.state.datetype),
        };

        this.getForecastSummary(forecastparams);

        this.setState({ [event.target.name]: event.target.value })
    }

    handleDateTypeChange = (event) => {
        let forecastparams = {
            filterdata: this.state.filterdata,
            piplineid: parseFloat(this.state.selectedPipline),
            type: parseFloat(this.state.value_type),
            fromdate: this.state.fromdate,
            todate: this.state.todate,
            datetype: parseFloat(event.target.value),
        };

        this.getForecastSummary(forecastparams);

        this.setState({ [event.target.name]: event.target.value })
    }

    handleTypeChange = (event) => {
        let forecastparams = {
            filterdata: this.state.filterdata,
            piplineid: parseFloat(this.state.selectedPipline),
            type: parseFloat(event.target.value),
            fromdate: this.state.fromdate,
            todate: this.state.todate,
            datetype: parseFloat(this.state.datetype),
        };

        this.getForecastSummary(forecastparams);

        this.setState({ [event.target.name]: event.target.value })
    }

    handleCloseDrawer = () => {
        this.setState({ drawerOpen: false, })
    }

    closedatepicker = () => {
        this.setState({ dateopen: false });
    }

    toggle = () => {
        this.setState({ dateopen: !this.state.dateopen });
    }

    setDateRange = (range) => {
        let startDate = moment(range.startDate).format('YYYY-MM-DD');
        let endDate = moment(range.endDate).format('YYYY-MM-DD');

        let forecastparams = {
            filterdata: this.state.filterdata,
            piplineid: parseFloat(this.state.selectedPipline),
            type: parseFloat(this.state.value_type),
            fromdate: startDate,
            todate: endDate,
            datetype: parseFloat(this.state.datetype),
        };

        this.getForecastSummary(forecastparams);

        if (range.label) {
            this.setState({ selectedDatelabel: range.label })
        } else {
            this.setState({ selectedDate: { from: startDate, to: endDate }, selectedDatelabel: "" });
        }
        this.setState({ fromdate: startDate, todate: endDate })
    }

    render() {
        // filter includes 
        var localStorageFilter = localStorage.getItem('selected_report_pipeline_summary_filter_id');
        let updateSaveFilterBtnDisabled = (this.state.filterdata == undefined || !this.state.filterdata.length) ? ((this.state.oldFilterOption == undefined || !this.state.oldFilterOption.length) ? true : false) : false;

        let { isOpenedFiltersDefault, filterlist, salesForecastSummary, pipelineList, reportTitile, reportSubTitle, dateopen, totalvalue, drawerOpen, totalWinRate, selectedPipline, value_type, datetype } = this.state;

        const options = {
            chart: {
                type: 'column',
                style: { fontFamily: 'Roboto, "Helvetica Neue", sans-serif' },
                backgroundColor: '#ffffff',
                borderRadius: 4,
            },
            title: { text: null },
            subtitle: { text: null },
            xAxis: {
                type: 'datetime',
                crosshair: { color: '#e2e8f0' },
                labels: { style: { color: '#6b7280', fontSize: '12px' } },
                lineColor: '#e2e8f0',
                tickColor: '#e2e8f0',
            },
            yAxis: {
                allowDecimals: false,
                title: { text: null },
                min: 0,
                gridLineColor: '#f1f5f9',
                labels: {
                    style: { color: '#6b7280', fontSize: '12px' },
                    formatter: function () {
                        return parseInt(value_type) == 1 ? '$' + this.value : this.value;
                    }
                }
            },
            tooltip: {
                headerFormat: '<div style="font-size:13px;font-weight:600;margin-bottom:6px;color:#1a2332">{point.key}</div>',
                pointFormat: '<div style="display:flex;justify-content:space-between;gap:16px;margin:3px 0"><span style="color:{series.color}">\u25CF {series.name}</span><b style="color:#1a2332">' + (parseInt(value_type) == 1 ? '$ ' : '') + '{point.y}</b></div>',
                footerFormat: '',
                shared: true,
                useHTML: true,
                backgroundColor: '#ffffff',
                borderColor: '#e2e8f0',
                borderRadius: 8,
                shadow: true,
                style: { padding: '10px' }
            },
            plotOptions: {
                column: {
                    pointPadding: 0.15,
                    borderWidth: 0,
                    borderRadius: 4,
                    dataLabels: { enabled: false }
                }
            },
            legend: {
                align: 'left',
                verticalAlign: 'top',
                itemStyle: { color: '#374151', fontSize: '12px', fontWeight: '500' },
                symbolRadius: 3,
            },
            credits: { enabled: false },
            series: [
                { name: 'Forecasted (Weighted)', color: '#86efac', data: salesForecastSummary.weight },
                { name: 'Won', color: '#22c55e', data: salesForecastSummary.won }
            ]
        };

        return (
            <React.Fragment >
                <div>
                    <div className="lead_content right-16 settings_view"
                        style={{ overflowY: "auto", overflowX: "hidden" }}>
                        <Card elevation={3} style={{ borderRadius: '8px', overflow: 'hidden' }}>
                            <div className="report_card">
                                {/* ── Header ── */}
                                <div className="report_header" style={{ background: 'linear-gradient(135deg,#f8fafb 0%,#ffffff 100%)', borderBottom: '1px solid #e8ecef', padding: '24px 28px 20px' }}>

                                    {/* Title row */}
                                    <Grid container direction="row" justify="space-between" alignItems="flex-start" onClick={this.closedatepicker}>
                                        <Grid item>
                                            <Typography variant="h5" style={{ fontWeight: 700, color: '#1a2332', marginBottom: '4px', fontSize: '22px' }}>
                                                {reportTitile}
                                            </Typography>
                                            <Typography variant="body2" style={{ color: '#6b7280', fontSize: '13px', maxWidth: '520px' }}>
                                                {reportSubTitle}
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Tooltip title="Filter Opportunities" arrow>
                                                <IconButton
                                                    onClick={() => this.handleOpenDrawer()}
                                                    style={{ background: '#f0f4f8', borderRadius: '8px', padding: '8px' }}
                                                >
                                                    <Badge badgeContent={this.state.filterdata ? this.state.filterdata.length : 0} color="primary">
                                                        <FilterListIcon style={{ color: '#374151' }} />
                                                    </Badge>
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>
                                    </Grid>

                                    {/* Stat card */}
                                    <Grid container direction="row" justify="flex-start" alignItems="center" onClick={this.closedatepicker} style={{ marginTop: '20px', marginBottom: '8px' }}>
                                        <div style={{
                                            display: 'flex', alignItems: 'center', gap: '12px',
                                            background: '#ffffff', border: '1px solid #e2e8f0',
                                            borderRadius: '10px', padding: '14px 20px',
                                            boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
                                        }}>
                                            <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'linear-gradient(135deg,#50ae55,#3d8b42)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <Icon style={{ color: '#fff', fontSize: '20px' }}>trending_up</Icon>
                                            </div>
                                            <div>
                                                <div style={{ fontSize: '26px', fontWeight: 700, color: '#1a2332', lineHeight: '1.1' }}>{totalvalue}</div>
                                                <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    Forecast
                                                    <Tooltip title="Your sales forecast based on Opportunity close date" arrow>
                                                        <Icon style={{ fontSize: '14px', color: '#9ca3af', cursor: 'pointer' }}>info_outline</Icon>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                        </div>
                                    </Grid>
                                    {/* Filter Bar */}
                                    <Grid
                                        container
                                        direction="row"
                                        justify="flex-start"
                                        alignItems="center"
                                        className="crm-all-report-filters"
                                        style={{ marginTop: '16px', gap: '8px', flexWrap: 'wrap', padding: '14px 0px 4px' }}
                                    >
                                        {/* Pipeline */}
                                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: '160px' }}>
                                            <InputLabel style={{ fontSize: '11px', fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px' }}>Pipeline</InputLabel>
                                            <CustomDropdown
                                                className="w-200"
                                                labelId="Pipeline-select-label"
                                                name="selectedPipline"
                                                id="Pipeline"
                                                value={selectedPipline}
                                                onChange={this.handlePiplineChange}
                                                onClick={this.closedatepicker}
                                            >
                                                <MenuItem value="0">All</MenuItem>
                                                {pipelineList && pipelineList.map((pipeline) => (
                                                    <MenuItem key={pipeline.id} value={pipeline.id}>{pipeline.name}</MenuItem>
                                                ))}
                                            </CustomDropdown>
                                        </div>

                                        {/* Divider */}
                                        <div style={{ width: '1px', height: '36px', background: '#e2e8f0', margin: '0 4px', alignSelf: 'flex-end', marginBottom: '2px' }} />

                                        {/* Saved Filters dropdown */}
                                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }} onClick={this.closedatepicker}>
                                            <InputLabel style={{ fontSize: '11px', fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px' }}>Saved Filter</InputLabel>
                                            <Button
                                                aria-describedby={'simple-popover'}
                                                variant="outlined"
                                                size="small"
                                                onClick={this.handleClick}
                                                style={{ textTransform: 'none', borderColor: '#d1d5db', color: '#374151', fontSize: '13px', justifyContent: 'space-between', padding: '4px 10px', background: '#fff' }}
                                            >
                                                <Tooltip title={this.state.displaySelectedFilterName}>
                                                    <span style={{ maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '13px' }}>
                                                        {this.state.displaySelectedFilterName}
                                                    </span>
                                                </Tooltip>
                                                <Icon style={{ fontSize: '18px', marginLeft: '4px' }}>{isOpenedFiltersDefault ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</Icon>
                                            </Button>
                                            <Popover
                                                id={'simple-popover'}
                                                open={this.state.isOpenedFiltersDefault}
                                                anchorEl={this.state.anchorEl}
                                                onClose={this.handleClose}
                                                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                                PaperProps={{ style: { borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.12)', marginTop: '4px' } }}
                                            >
                                                <Card elevation={0} style={{ width: '260px', padding: '8px 0' }}>
                                                    {isOpenedFiltersDefault && <>
                                                        <div style={{ padding: '8px 16px 4px', fontSize: '11px', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Private Filters</div>
                                                        <ul style={{ listStyle: 'none', padding: '0 8px', margin: 0 }}>
                                                            {this.state.filterlist.map((item) => {
                                                                let star_icon = item.isdefault ? "star" : "star_border";
                                                                if (item.fitertype == 1 && item.id != localStorage.getItem('selected_report_pipeline_summary_filter_id')) {
                                                                    return (
                                                                        <li key={item.id} style={{ display: 'flex', alignItems: 'center', padding: '4px 8px', borderRadius: '6px', cursor: 'pointer' }}
                                                                            onMouseEnter={e => e.currentTarget.style.background = '#f3f4f6'}
                                                                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                                                                        >
                                                                            <span style={{ flex: 1, fontSize: '13px', color: '#374151' }} onClick={() => this.handleFilterChange(item)}>{item.filtername}</span>
                                                                            <IconButton size="small"><Icon onClick={() => this.updateOpportunityFilter(item)} style={{ fontSize: '16px', color: '#9ca3af' }}>settings</Icon></IconButton>
                                                                            <IconButton size="small"><Icon onClick={() => this.setState({ isDeleteFilter: true, filterDeleteId: item.id })} style={{ fontSize: '16px', color: '#9ca3af' }}>delete</Icon></IconButton>
                                                                            <IconButton size="small"><Icon onClick={() => this.updateFilterDefaultReport(item)} style={{ fontSize: '16px', color: item.isdefault ? '#f59e0b' : '#9ca3af' }}>{star_icon}</Icon></IconButton>
                                                                        </li>
                                                                    );
                                                                }
                                                                return null;
                                                            })}
                                                        </ul>
                                                        <Divider style={{ margin: '8px 0' }} />
                                                        <div style={{ padding: '4px 16px 4px', fontSize: '11px', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Public Filters</div>
                                                        <ul style={{ listStyle: 'none', padding: '0 8px', margin: 0 }}>
                                                            {this.state.filterlist.map((items) => {
                                                                let star_icon = items.isdefault ? "star" : "star_border";
                                                                if (items.fitertype == 0 && items.id != localStorage.getItem('selected_report_pipeline_summary_filter_id')) {
                                                                    return (
                                                                        <li key={items.id} style={{ display: 'flex', alignItems: 'center', padding: '4px 8px', borderRadius: '6px', cursor: 'pointer' }}
                                                                            onMouseEnter={e => e.currentTarget.style.background = '#f3f4f6'}
                                                                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                                                                        >
                                                                            <span style={{ flex: 1, fontSize: '13px', color: '#374151' }} onClick={() => this.handleFilterChange(items)}>{items.filtername}</span>
                                                                            {!["3"].includes(items.id) && <>
                                                                                <IconButton size="small"><Icon onClick={() => this.updateOpportunityFilter(items)} style={{ fontSize: '16px', color: '#9ca3af' }}>settings</Icon></IconButton>
                                                                                <IconButton size="small"><Icon onClick={() => this.setState({ isDeleteFilter: true, filterDeleteId: items.id })} style={{ fontSize: '16px', color: '#9ca3af' }}>delete</Icon></IconButton>
                                                                            </>}
                                                                            <IconButton size="small"><Icon onClick={() => this.updateFilterDefaultReport(items)} style={{ fontSize: '16px', color: items.isdefault ? '#f59e0b' : '#9ca3af' }}>{star_icon}</Icon></IconButton>
                                                                        </li>
                                                                    );
                                                                }
                                                                return null;
                                                            })}
                                                        </ul>
                                                    </>}
                                                </Card>
                                            </Popover>
                                        </div>

                                        {/* Divider */}
                                        <div style={{ width: '1px', height: '36px', background: '#e2e8f0', margin: '0 4px', alignSelf: 'flex-end', marginBottom: '2px' }} />

                                        {/* Date Picker */}
                                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: '160px' }}>
                                            <InputLabel style={{ fontSize: '11px', fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px' }}>Close Date</InputLabel>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                onClick={this.toggle}
                                                startIcon={<Icon style={{ fontSize: '16px' }}>date_range</Icon>}
                                                style={{ textTransform: 'none', borderColor: '#d1d5db', color: '#374151', fontSize: '13px', padding: '4px 10px', background: '#fff', justifyContent: 'flex-start' }}
                                            >
                                                {this.state.selectedDatelabel !== "" ? this.state.selectedDatelabel : `${this.state.selectedDate.from} – ${this.state.selectedDate.to}`}
                                            </Button>
                                        </div>

                                        {/* Divider */}
                                        <div style={{ width: '1px', height: '36px', background: '#e2e8f0', margin: '0 4px', alignSelf: 'flex-end', marginBottom: '2px' }} />

                                        {/* Group By */}
                                        <div style={{ display: 'flex', flexDirection: 'column' }} onClick={this.closedatepicker}>
                                            <InputLabel style={{ fontSize: '11px', fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '2px' }}>Group By</InputLabel>
                                            <RadioGroup row name="datetype" value={datetype} onChange={this.handleDateTypeChange} style={{ flexWrap: 'nowrap', gap: '2px' }}>
                                                {[{ v: "1", l: "Daily" }, { v: "2", l: "Weekly" }, { v: "3", l: "Monthly" }, { v: "4", l: "Quarterly" }].map(opt => (
                                                    <FormControlLabel key={opt.v} value={opt.v} control={<Radio color="primary" size="small" />} label={<span style={{ fontSize: '13px' }}>{opt.l}</span>} style={{ marginRight: '4px' }} />
                                                ))}
                                            </RadioGroup>
                                        </div>

                                        {/* Divider */}
                                        <div style={{ width: '1px', height: '36px', background: '#e2e8f0', margin: '0 4px', alignSelf: 'flex-end', marginBottom: '8px' }} />

                                        {/* Value Type */}
                                        <div style={{ display: 'flex', flexDirection: 'column' }} onClick={this.closedatepicker}>
                                            <InputLabel style={{ fontSize: '11px', fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '2px' }}>Show As</InputLabel>
                                            <RadioGroup row name="value_type" value={value_type} onChange={this.handleTypeChange} style={{ flexWrap: 'nowrap', gap: '2px' }}>
                                                {[{ v: "1", l: "Value" }, { v: "2", l: "Count" }].map(opt => (
                                                    <FormControlLabel key={opt.v} value={opt.v} control={<Radio color="primary" size="small" />} label={<span style={{ fontSize: '13px' }}>{opt.l}</span>} style={{ marginRight: '4px' }} />
                                                ))}
                                            </RadioGroup>
                                        </div>

                                        {/* Date Range Picker (floating) */}
                                        <div className="crm-all-report-filters-daterange">
                                            <DateRangePicker
                                                open={dateopen}
                                                toggle={this.toggle}
                                                definedRanges={this.state.definedRanges}
                                                onChange={(range) => this.setDateRange(range)}
                                                initialDateRange={{ startDate: moment().startOf('year'), endDate: moment().endOf('year') }}
                                            />
                                        </div>
                                    </Grid>
                                </div>

                                {/* Chart */}
                                <div className="report_content" onClick={this.closedatepicker} style={{ padding: '24px 28px 28px', background: '#fafbfc' }}>
                                    <div style={{ background: '#fff', borderRadius: '8px', border: '1px solid #e8ecef', padding: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
                                        <HighchartsReact
                                            highcharts={Highcharts}
                                            options={options}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
                {/*-------------------- filter start------------------------- */}
                <Drawer
                    width={"100px"}
                    variant="temporary"
                    anchor={"right"}
                    className="drawer_right"
                    open={drawerOpen}
                    onClose={this.handleCloseDrawer}
                    ModalProps={{ keepMounted: true }}
                    onClick={this.closedatepicker}
                >
                    <React.Fragment>
                        <div className="frame_body">
                            <div className="filter_Drawer_header" style={{ background: '#fff' }}>
                                <Grid container justify="space-between" alignItems="center" style={{ padding: '12px 16px', borderBottom: '1px solid #e8ecef' }}>
                                    <Grid item>
                                        <IconButton size="small" onClick={this.handleCloseDrawer} style={{ background: '#f3f4f6', borderRadius: '8px' }}>
                                            <Icon style={{ fontSize: '18px' }}>arrow_forward</Icon>
                                        </IconButton>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="subtitle1" style={{ fontWeight: 600, color: '#1a2332', fontSize: '15px' }}>Filter Opportunities</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            onClick={() => this.handleFilterChange(this.state.allDefaultKeyFilter)}
                                            type="button"
                                            size="small"
                                            variant="outlined"
                                            style={{ textTransform: 'none', borderColor: '#e2e8f0', color: '#6b7280', fontSize: '12px', borderRadius: '6px' }}
                                        >
                                            Clear All
                                        </Button>
                                    </Grid>
                                    <Grid item md={12} className={"report_opportunity_filter"}>
                                        <div className="v_scroll position-relative ml-16 mt-16 pr-16">
                                            {opportunityFilterComponent(this)}
                                        </div>
                                        <div style={{ padding: '12px 16px', borderTop: '1px solid #e8ecef', display: 'flex', gap: '8px' }}>
                                            <Button
                                                type="button"
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                style={{ textTransform: 'none', borderRadius: '6px', fontSize: '13px' }}
                                                onClick={() => this.handleSavefilterDialoge()}
                                            >
                                                Save Filter
                                            </Button>
                                            {localStorageFilter && !["3"].includes(localStorageFilter) &&
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    color="primary"
                                                    size="small"
                                                    style={{ textTransform: 'none', borderRadius: '6px', fontSize: '13px' }}
                                                    onClick={() => this.updateFilterOptions()}
                                                >
                                                    Update Filter
                                                </Button>
                                            }
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                    </React.Fragment>
                </Drawer>

                <Dialog
                    fullWidth={true}
                    maxWidth={'xs'}
                    open={this.state.filterSaveDialoge}
                    onClose={() => this.handleSavefilterDialogeClose()}
                    disableBackdropClick
                    disableEscapeKeyDown
                    aria-labelledby="filter-save-dialog-title"
                    PaperProps={{ style: { borderRadius: '10px' } }}
                >
                    <DialogTitle id="filter-save-dialog-title" style={{ padding: '20px 24px 12px' }}>
                        <Typography variant="h6" style={{ fontWeight: 600, fontSize: '16px', color: '#1a2332' }}>
                            {!this.state.filterUpdateId ? "Save New Filter" : "Edit Filter"}
                        </Typography>
                    </DialogTitle>
                    <Divider />
                    <DialogContent style={{ padding: '20px 24px' }}>
                        <ValidatorForm instantValidate={false} ref="form">
                            <FormControl error={this.state.filternameError} className="w-100 input_bx">
                                <InputLabel htmlFor="component-error">Filter Name</InputLabel>
                                <Input
                                    type="text"
                                    id={'filtername'}
                                    label={'Filter Name'}
                                    className="w-100 input_bx"
                                    onChange={(event) => this.handleChange(event)}
                                    name={'filtername'}
                                    value={this.state.filtername}
                                />
                                {this.state.filternameError && <FormHelperText id="component-error-text">This field is required</FormHelperText>}
                            </FormControl>
                            <br /><br />
                            <Typography variant="caption" style={{ fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '11px' }}>Visibility</Typography>
                            <RadioGroup name="fitertype" value={this.state.fitertype} onChange={(event) => this.handleChange(event)} row style={{ marginTop: '4px' }}>
                                <FormControlLabel value="1" control={<Radio color="primary" size="small" />} label={<span style={{ fontSize: '13px' }}>Private</span>} labelPlacement="end" />
                                <FormControlLabel value="0" control={<Radio color="primary" size="small" />} label={<span style={{ fontSize: '13px' }}>Public</span>} labelPlacement="end" />
                            </RadioGroup>
                        </ValidatorForm>
                    </DialogContent>
                    <DialogActions style={{ padding: '12px 24px 16px', gap: '8px' }}>
                        {updateSaveFilterBtnDisabled && <p style={{ color: '#e95455', fontSize: '12px', flex: 1, margin: 0 }}>Please select filter options first</p>}
                        <Button onClick={() => this.handleSavefilterDialogeClose()} style={{ textTransform: 'none', color: '#6b7280', borderRadius: '6px' }}>Cancel</Button>
                        {!this.state.filterUpdateId && <Button variant="contained" disabled={updateSaveFilterBtnDisabled} type="button" color="primary" style={{ textTransform: 'none', borderRadius: '6px' }} onClick={() => this.handleSavefilter()}>Save</Button>}
                        {this.state.filterUpdateId && <Button variant="contained" disabled={updateSaveFilterBtnDisabled} type="button" color="primary" style={{ textTransform: 'none', borderRadius: '6px' }} onClick={() => this.handleUpdatefilter()}>Update</Button>}
                    </DialogActions>
                </Dialog>
                <Dialog
                    fullWidth={true}
                    maxWidth={'xs'}
                    open={this.state.isDeleteFilter}
                    onClose={this.filterRemoveDialoge}
                    disableBackdropClick
                    disableEscapeKeyDown
                    aria-labelledby="ar-remove-dialog-title"
                    PaperProps={{ style: { borderRadius: '10px' } }}
                >
                    <DialogTitle id="ar-remove-dialog-title" style={{ padding: '20px 24px 12px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: '#fee2e2', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Icon style={{ color: '#ef4444', fontSize: '18px' }}>delete_outline</Icon>
                            </div>
                            <Typography variant="subtitle1" style={{ fontWeight: 600, fontSize: '15px', color: '#1a2332' }}>Delete Filter</Typography>
                        </div>
                    </DialogTitle>
                    <DialogContent style={{ padding: '4px 24px 16px' }}>
                        <Typography variant="body2" style={{ color: '#6b7280', fontSize: '13px' }}>Are you sure you want to delete this filter? This action cannot be undone.</Typography>
                    </DialogContent>
                    <DialogActions style={{ padding: '8px 24px 16px', gap: '8px' }}>
                        <Button onClick={this.filterRemoveDialoge} style={{ textTransform: 'none', color: '#6b7280', borderRadius: '6px' }}>Cancel</Button>
                        <Button
                            type="button"
                            variant="contained"
                            onClick={() => this.confirmDeleteFilter()}
                            style={{ textTransform: 'none', background: '#ef4444', color: '#fff', borderRadius: '6px' }}
                        >
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
                {/*-------------------- filter done------------------------- */}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    settingReducer: state.settingReducer,
    reportReducer: state.reportReducer,
    apolloClient: state.apolloClient,
    notification: state.notification,
});
const mapDispatchToProps = dispatch => {
    return {

        getPipelines: (client) => dispatch(actions.getPipelines(client)),
        getTagsList: (client) => dispatch(actions.getTagsList(client)),
        getUserList: (client) => dispatch(actions.getUserList(client)),
        getActivityTypes: (client) => dispatch(actions.getActivityTypes(client)),
        customFieldList: (client, value) => dispatch(actions.customFieldList(client, value)),

        salesForecastSummary: (client, value) => dispatch(actions.salesForecastSummary(client, value)),
        getReportFilterList: (client, value) => dispatch(actions.getReportFilterList(client, value)),
        saveReportFilterDetail: (client, value) => dispatch(actions.saveReportFilterDetail(client, value)),
        deleteReportFilter: (client, value) => dispatch(actions.deleteReportFilter(client, value)),
        updateReportFilterDefault: (client, value) => dispatch(actions.updateReportFilterDefault(client, value)),
        updateReportFilterDetail: (client, value) => dispatch(actions.updateReportFilterDetail(client, value)),

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SalesForecast);
